import axios from '@/utils/http.js';

const urls = {
  addEmployee: '/user/add',
  queryEmployee: '/user/load',
  modifyEmployee: '/user/updateUserInfo',
  leaveEmployee: '/user/leave',
  statisticsBymonth: '/user/statisticsBymonth',
  repairRecord: '/user/repairRecord',
  delUser: '/user/delUser',
  getArrangeData: '/user/getArrangeData',
};

export const addEmployee = function (options) {
  options.url = urls.addEmployee;
  return axios.post(options);
};
export const queryEmployee = function (options) {
  options.url = urls.queryEmployee;
  return axios.get(options);
};
export const modifyEmployee = function (options) {
  options.url = urls.modifyEmployee;
  return axios.post(options);
};
export const leaveEmployee = function (options) {
  options.url = urls.leaveEmployee;
  return axios.get(options);
};
export const statisticsBymonth = function (options) {
  options.url = urls.statisticsBymonth;
  return axios.get(options);
};
export const repairRecord = function (options) {
  options.url = urls.repairRecord;
  return axios.get(options);
};
export const delUser = function (options) {
  options.url = urls.delUser;
  return axios.delete(options);
};

export const getArrangeData = function (options) {
  options.url = urls.getArrangeData;
  return axios.get(options);
};
